import { createAction } from 'redux-actions';
import { HOME_GET_CODIGUERAS, HOME_GET_MEDICAMENTOS } from '../constants/home';
export const setHomeCodiguera = createAction(HOME_GET_CODIGUERAS, (m) => m);
export const setHomeMedicamentos= createAction(HOME_GET_MEDICAMENTOS, (c) => c);